<div class="main-container" *ngIf="selectedRequest">
    <table class="main-table">
        <tr>
            <td colspan="3">{{selectedRequest.familyName}}, {{selectedRequest.firstName}}</td>
        </tr>
        <tr class="inner-table-container-line">
            <td class="inner-table-container">
                <table class="inner-table">
                    <tr>
                        <td colspan="2" class="title-container">
                            Réservation
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Programme demandé
                        </td>
                        <td class="important-text">
                            {{selectedRequest.programme}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Options du programme
                        </td>
                        <td>
                            {{selectedRequest.programmeOption}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Leçons par semaine
                        </td>
                        <td>
                            {{selectedRequest.lessonsPerWeek}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Date de départ
                        </td>
                        <td>
                            {{selectedRequest.startDay.toDate() | date:"dd/MM/yyyy"}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Date de retour
                        </td>
                        <td>
                            {{selectedRequest.endDay.toDate() | date:"dd/MM/yyyy"}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Durée(weeks)
                        </td>
                        <td>
                            {{duration}}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="title-container">
                            Logement
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Type de logement
                        </td>
                        <td>
                            {{selectedRequest.accommodationType}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Chambre
                        </td>
                        <td>
                            {{selectedRequest.roomType}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Pension
                        </td>
                        <td>
                            {{selectedRequest.board}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Fumeurs OK
                        </td>
                        <td>
                            {{selectedRequest.nonSmokingFamily}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Jeunes enfants OK
                        </td>
                        <td>
                            {{selectedRequest.familyWithNoKids}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Animaux OK
                        </td>
                        <td>
                            {{selectedRequest.familyWithNoPets}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Allergies
                        </td>
                        <td>
                            {{selectedRequest.allergyOrMedicalIssues}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Hobbies
                        </td>
                        <td>
                            {{selectedRequest.hobbies}}
                        </td>
                    </tr>
                </table>
            </td>
            <td class="inner-table-container">
                <table class="inner-table">
                    <tr>
                        <td colspan="2" class="title-container">
                            Etudiant
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Nom de famille
                        </td>
                        <td>
                            {{selectedRequest.familyName}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Prénom
                        </td>
                        <td>
                            {{selectedRequest.firstName}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Sexe
                        </td>
                        <td>
                            {{selectedRequest.gender}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Date de naissance
                        </td>
                        <td>
                            {{selectedRequest.birthDate.toDate() | date:"dd/MM/yyyy"}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Age
                        </td>
                        <td>
                            {{selectedRequest.age}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            BirthPlace
                        </td>
                        <td>
                            {{selectedRequest.birthPlace}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Nationalité
                        </td>
                        <td>
                            {{selectedRequest.nationality}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Language
                        </td>
                        <td>
                            {{selectedRequest.language}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Souffre de
                        </td>
                        <td>
                            {{selectedRequest.learningDifficulty}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Portable
                        </td>
                        <td>
                            {{selectedRequest.phoneNumber}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Email
                        </td>
                        <td>
                            {{selectedRequest.email}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Adresse et numéro
                        </td>
                        <td>
                            {{selectedRequest.street}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Ville
                        </td>
                        <td>
                            {{selectedRequest.city}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Code postal
                        </td>
                        <td>
                            {{selectedRequest.postalCode}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Pays
                        </td>
                        <td>
                            {{selectedRequest.country}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Niveau de langue
                        </td>
                        <td>
                            {{selectedRequest.targetLanguageLevel}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Le participant est adulte
                        </td>
                        <td>
                            {{studentIsAdult?"Yes":"No"}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Noms des parents
                        </td>
                        <td>
                            {{selectedRequest.parentName}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Profession des parents
                        </td>
                        <td>
                            {{selectedRequest.parentProfession}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Email des parents
                        </td>
                        <td>
                            {{selectedRequest.parentEmail}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Tel. des parents
                        </td>
                        <td>
                            {{selectedRequest.parentPhone}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            School
                        </td>
                        <td>
                            {{selectedRequest.school}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Language teacher
                        </td>
                        <td>
                            {{selectedRequest.languageTeacher}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            School address
                        </td>
                        <td>
                            {{selectedRequest.schoolAddress}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Age of siblings
                        </td>
                        <td>
                            {{selectedRequest.siblingsAge}}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="title-container">
                            Voyage
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Voyage
                        </td>
                        <td>
                            {{selectedRequest.travelWithLvi}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Transfert
                        </td>
                        <td>
                            {{selectedRequest.airportTransferType}}
                        </td>
                    </tr>
                </table>
            </td>
            <td class="inner-table-container">
                <table class="inner-table">
                    <tr>
                        <td colspan="2" class="title-container">
                            Divers
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Agent
                        </td>
                        <td>
                            {{selectedRequest.agent?.name}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Assurance annulation?
                        </td>
                        <td>
                            {{selectedRequest.needCancellationGuarantee}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Assurance médicale?
                        </td>
                        <td>
                            {{selectedRequest.needMedicalInsurance}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Source
                        </td>
                        <td>
                            {{selectedRequest.informationSource}}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="title-container">
                            Facturation
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Qui facturer
                        </td>
                        <td>
                            {{selectedRequest.billingContact}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Nom
                        </td>
                        <td>
                            {{selectedRequest.billingPersonName}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Devise de facturation
                        </td>
                        <td>
                            {{selectedRequest.billingCurrency}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Pays de facturation
                        </td>
                        <td>
                            {{selectedRequest.billingPersonCountry}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Methode de facturation
                        </td>
                        <td>
                            {{selectedRequest.paymentMethod}}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="title-container">
                            Emergency Contact
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Email
                        </td>
                        <td>
                            {{selectedRequest.emergencyContactEmail}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Name
                        </td>
                        <td>
                            {{selectedRequest.emergencyContactName}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Phone
                        </td>
                        <td>
                            {{selectedRequest.emergencyContactPhone}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Type
                        </td>
                        <td>
                            {{selectedRequest.emergencyContactType}}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="title-container">
                            Comment
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Text
                        </td>
                        <td>
                            {{selectedRequest.comment}}
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</div>